import React, { useState, useEffect } from 'react';
import { FaCamera } from "react-icons/fa";

export default function ProfileImage(props) {
  const inputRef = React.useRef();
  const triggerFileSelectPopup = () => {
    if (inputRef.current) inputRef.current.click();
  };
  const { profileImage, setImageFile, formType } = props;
  const [viewOnly, setViewOnly] = useState(false);

  useEffect(() => {
    if (formType === "Edit" || formType === "New") {
      setViewOnly(false);
    } else {
      setViewOnly(true);
    }
  }, [formType]);

  const handleFileSelection = (event) => {
    event.preventDefault();
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setImageFile(selectedFile);
      const tprofile = document.getElementById("profile");
      if (tprofile) {
        tprofile.src = URL.createObjectURL(selectedFile);
      }
    }
  };

  const handleImageError = (e) => {
    e.target.src = "https://s3.ap-south-1.amazonaws.com/idntica.com/avatar/profileImage/defaultAvatar.jpeg";
  };

  return (
    <div className="profile-image-container text-center mb-4">
      <div className="position-relative d-inline-block">
        <img
          id="profile"
          src={profileImage}
          onError={handleImageError}
          alt="Profile Avatar"
          style={{
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "4px solid var(--card-bg)",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)"
          }}
        />

        {!viewOnly && (
          <>
            <input
              type="file"
              accept="image/*"
              ref={inputRef}
              onChange={handleFileSelection}
              style={{ display: "none" }}
            />
            <button
              type="button"
              className="btn btn-primary position-absolute bottom-0 end-0 rounded-circle p-0 d-flex align-items-center justify-content-center shadow"
              onClick={triggerFileSelectPopup}
              style={{
                width: "36px",
                height: "36px",
                border: "2.5px solid #ffffff",
                cursor: "pointer"
              }}
              title="Upload New Photo"
            >
              <FaCamera style={{ fontSize: "14px", color: "#ffffff" }} />
            </button>
          </>
        )}
      </div>
      {/*<div className="small text-muted mt-2">
          Click the camera icon to select a new passport-size photo
        </div>*/}
    </div>
  );
}